<script setup lang="ts">
import FilterChip from '@/components/ui/FilterChip.vue';
import type { TimetableDay } from './types';

defineProps<{
  days: Array<TimetableDay>;
  selectedKey: string;
}>();

const emit = defineEmits<{ select: [key: string] }>();
</script>

<template>
  <div class="day-chips">
    <FilterChip
      v-for="day in days"
      :key="day.key"
      :active="day.key === selectedKey"
      :label="day.label"
      @click="emit('select', day.key)"
    />
  </div>
</template>

<style lang="scss">
// The week overflows a phone width: the chips scroll horizontally rather than
// wrap, so the list below always starts at the same height.
.day-chips {
  display: flex;
  gap: $spacing-2;
  overflow-x: auto;
  padding: $spacing-4 $spacing-5;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
